import GridLayoutBody from "./GridLayoutBody";
import GridLayoutSidebar from "./GridLayoutSidebar";
import ExpressBanner from "~/components/ExpressBanner";
import Navbar from "~/components/Navbar";
import type { Layout } from "~/types";

const GridLayout: Layout & {
	Sidebar: typeof GridLayoutSidebar;
	Body: typeof GridLayoutBody;
} = ({ children, breadcrumbs }) => {
	return (
		<div className="flex laptop:h-screen min-h-screen w-screen flex-col laptop:overflow-hidden">
			<Navbar breadcrumbs={breadcrumbs} />

			<div className="mx-auto flex h-full w-full max-w-screen-2xl flex-1 laptop:overflow-hidden">
				{children}
			</div>

			<ExpressBanner />
		</div>
	);
};

GridLayout.Sidebar = GridLayoutSidebar;
GridLayout.Body = GridLayoutBody;

export default GridLayout;
